import React, { useEffect } from 'react';
import { useTranslate, required, TextInput, SelectInput } from 'react-admin';
import JsonInput from '~/components/ra/JsonInput';
import { useAccountExternalLinkTypes } from '~/hooks/accountExternalLinks';
import { useForm } from 'react-final-form';
import { HiddenInput } from '../ra';
import lodashGet from 'lodash/get';

interface Props {
  profileId: string;
  profileType: string;
  accountId: string;
  edit?: boolean;
  formData?: any;
}

const label = (key: string) => `components.AccountExternalLinks.${key}`;

const AccountExternalLinkForm = (props: Props) => {
  const { profileId, profileType, accountId, edit, formData } = props;
  const form = useForm();
  useEffect(() => {
    form.destroyOnUnregister = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedSystem = lodashGet(formData, 'system');
  const linkType = lodashGet(formData, 'linkType');

  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));

  const { data: linkTypes, isLoading } = useAccountExternalLinkTypes({
    enabled: !edit,
  });
  const avalableSystems = (linkTypes ? Object.keys(linkTypes) : []).map((sys) => ({
    id: sys,
    name: sys,
  }));
  const types = selectedSystem
    ? linkTypes?.[selectedSystem]?.map((type: string) => ({ id: type, name: type }))
    : [];

  return (
    <>
      <HiddenInput source='accountId' defaultValue={accountId} />
      <HiddenInput source='profileId' defaultValue={profileId} />
      <HiddenInput source='profileType' defaultValue={profileType} />
      <HiddenInput source='referenceId' defaultValue={[]} />
      <HiddenInput source='id' />
      <SelectInput
        source='status'
        label={t('status')}
        choices={[
          { id: 'INITIAL', name: t('INITIAL') },
          { id: 'ACTIVE', name: t('ACTIVE') },
          { id: 'PENDING', name: t('PENDING') },
          { id: 'REJECTED', name: t('REJECTED') },
          { id: 'CLOSED', name: t('CLOSED') },
        ]}
        fullWidth
        validate={required()}
      />
      {!edit && (
        <SelectInput
          source='system'
          label={t('system')}
          fullWidth
          choices={avalableSystems}
          isLoading={isLoading}
          validate={required()}
        />
      )}
      {!edit && selectedSystem && (
        <SelectInput
          source='linkType'
          label={t('linkType')}
          fullWidth
          choices={types}
          isLoading={isLoading}
          validate={required()}
        />
      )}
      {/* Render Mambu-specific form if applicable, otherwise generic JSON editor */}
      {linkType &&
        (linkType.startsWith('MAMBU_') ? (
          <TextInput
            key={`${linkType}-encodedKey`}
            source='encodedKey'
            label={t('encodedKey')}
            fullWidth
          />
        ) : (
          <JsonInput
            source='additionalData'
            label={t('additionalData')}
            validationError={t('invalidJson')}
            required
            rows={30}
          />
        ))}
      <JsonInput
        source='identificationDetails.details'
        label={t('identificationDetails')}
        validationError={t('invalidJson')}
        required
        initialValue='{}'
        rows={30}
      />
    </>
  );
};

export default AccountExternalLinkForm;
